module.exports = __webpack_public_path__ + "img/wrh.a61d69c0.png";